import { render, staticRenderFns } from "./NacexShippingTable.vue?vue&type=template&id=5347dffc&scoped=true"
import script from "./NacexShippingTable.vue?vue&type=script&lang=js"
export * from "./NacexShippingTable.vue?vue&type=script&lang=js"
import style0 from "./NacexShippingTable.vue?vue&type=style&index=0&id=5347dffc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5347dffc",
  null
  
)

export default component.exports